import {
  Modal,
  message,
  Row,
  Col,
  Button,
  Table,
  Input,
  FloatButton,
  Spin,
  notification,
  Form,
  Space,
  Select,
  Calendar,
  Badge,
  Segmented,
} from "antd";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  BASE_URL_BEN,
  GET_LIST_CANCEL_HAND_DATE,
  HEADERS_EXPORT_BEN,
  POST_LOAD_WCC_DAY,
  POST_UPDATE_PARCEL,
} from "../../../API/apiUrls";
import dayjs from "dayjs";
import {
  RestOutlined,
  SearchOutlined,
  FileExcelOutlined,
  SaveOutlined,
  InfoCircleOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

import { findParcelDuplicates } from "../../../../hook/CheckDuplicateParcel";
import { excelForPostOffice } from "../../cancelContract/export/ExportPostOffice";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { Link } from "react-router-dom";

const ExportCancel = ({ open, close }) => {
  const { Search } = Input;
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [arrData, setArrData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [datePicker, setDatePicker] = useState(null);
  const [form] = Form.useForm();
  const mailRefs = useRef({}); // ช่อง ems จดหมายของแต่ละแถว
  const responseRefs = useRef({}); // ช่อง ems ใบตอบกลับของแต่ละแถว
  const scrollRef = useRef(null); // กล่องที่ให้เลื่อนภายใน
  const [optionTime, setOptionTime] = useState([]);
  const [optionTimeSelect, setOptionTimeSelect] = useState([]);
  const [calendarPoint, setCalendarPoint] = useState([]);
  const [btnCheckCalendar, setBtnCheckCalendar] = useState(false);
  const [calendarMode, setCalendarMode] = useState("month"); // 'month' | 'year'
  const [calendarValue, setCalendarValue] = useState(dayjs()); // ค่าวัน/เดือนที่แสดง

  // เติมค่าเริ่มต้นเข้า Form ทุกครั้งที่ arrayTable เปลี่ยน
  useEffect(() => {
    const rowsObj = arrayTable.reduce((acc, r) => {
      acc[r.key] = {
        parcelNo: r.parcelNo ?? "",
        parcelNoResponse: r.parcelNoResponse ?? "",
      };
      return acc;
    }, {});
    form.setFieldsValue({ rows: rowsObj });
  }, [arrayTable, form]);

  // เขียน helper ให้ mirror ค่าลง state ของตาราง (เพื่อให้ render ทันที)
  const writeThrough = (rowKey, field, val) => {
    setArrayTable((prev) =>
      prev.map((r) => (r.key === rowKey ? { ...r, [field]: val } : r)),
    );
    setArrData((prev) =>
      prev.map((r) => (r.key === rowKey ? { ...r, [field]: val } : r)),
    );
  };

  // เติมค่าเริ่มต้นเข้า Form ทุกครั้งที่ arrayTable เปลี่ยน
  useEffect(() => {
    loadCalendar();
  }, []);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const loadCalendar = async () => {
    setLoading(true);
    try {
      await axios
        .get(GET_LIST_CANCEL_HAND_DATE, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          console.log("res.data", res.data);
          if (res.status === 200) {
            if (res.data.message === "ไม่พบข้อมูล") {
              message.warning("ไม่พบข้อมูล");
            } else {
              setCalendarPoint(res.data);
            }
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
            setArrayTable([]);
            setArrData([]);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const queryData = (status, dateValue, calendarSearch) => {
    const payload = {
      flagStatus: 1,
      docTime: calendarSearch
        ? dayjs(dateValue).format("YYYY-MM-DD")
        : dayjs(datePicker).format("YYYY-MM-DD"),
    };
    console.log(payload);
    console.log(status);

    if ((datePicker || dateValue) && status) {
      loadData(payload);
    }
  };

  const loadData = async (payload) => {
    setArrData([]);
    setArrayTable([]);
    setOptionTime([]);
    setOptionTimeSelect([]);
    setLoading(true);
    console.log("dataDefault", payload);
    try {
      await axios
        .post(POST_LOAD_WCC_DAY, payload, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          console.log("res.data", res.data);

          if (res.status === 200) {
            if (res.data.message === "ไม่พบข้อมูล") {
              message.warning("ไม่พบข้อมูล");
            } else {
              // เพิ่ม key สำหรับ table
              let i = 1;
              const newDataUse = res.data.map((item) => ({
                ...item,
                key: i++,
              }));
              handleTime(newDataUse);
              setArrData(newDataUse);
            }
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
            setArrayTable([]);
            setArrData([]);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTime = (data = []) => {
    const seen = new Set();

    const sel = data
      .filter((x) => x?.datetime)
      .filter((x) => {
        const key = dayjs(x.datetime).format("YYYY-MM-DD HH:mm");
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((x) => ({
        value: x.datetime,
        label: dayjs(x.datetime).format("DD/MM/YYYY HH:mm"),
      }));

    setOptionTime(sel);
  };

  const handleSelectTime = (val) => {
    setLoading(true);
    console.log("setLoading(true);", val);
    setOptionTimeSelect(val);

    // ⭐ แปลง val เป็นระดับนาที
    const valMinute = dayjs(val).format("YYYY-MM-DD HH:mm");

    // ⭐ เปรียบเทียบระดับนาที
    const dataSelect = arrData.filter(
      (item) => dayjs(item.datetime).format("YYYY-MM-DD HH:mm") === valMinute,
    );

    const newData = dataSelect.map((item, index) => ({
      ...item,
      key: index + 1,
    }));

    setTimeout(() => {
      setLoading(false);
    }, 500);

    setArrayTable(newData);
    console.log("res Role", newData);
  };
  const search = (event) => {
    console.log("query--->", event.target.value);
    onSearch(event.target.value);
  };

  const onSearch = (value) => {
    console.log("value", value, arrData);
    let result = arrData?.filter(
      (item) =>
        (item.contractNo.includes(value.trim()) ||
          item.customerFullname.includes(value.trim()) ||
          item?.parcelNo === value.trim() ||
          item?.parcelNoResponse === value.trim()) &&
        item.datetime === optionTimeSelect,
    );
    console.log("sadasdadasd", result);

    if (result) {
      setArrayTable(result);
    } else {
      setArrayTable(arrData);
    }
  };

  const putDataParcel = async (dataParcel) => {
    setLoading(true);
    if (!dataParcel || dataParcel.length === 0) {
      message.error("ไม่มีข้อมูล !!");
      setLoading(false);
      return;
    }
    console.log("dataParcel", dataParcel);

    try {
      const res = await axios.post(
        `${BASE_URL_BEN}${POST_UPDATE_PARCEL}`,
        dataParcel,
        { headers: HEADERS_EXPORT_BEN },
      );
      const { status, data } = res;

      if (status === 200) {
        message.success("อัพเดทเลขไปรษณีย์สำเร็จ");
      } else if (status === 201) {
        message.warning(String(data?.OK));
      } else {
        message.success(`สำเร็จ (รหัส ${status})`);
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 500) {
        message.error(`ข้อมูลเลขไปรษณีย์ซ้ำกับข้อมูลเดิม !!`);
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const confirmInsert = () => {
    setLoading(true);
    const { sameField, crossField } = findParcelDuplicates(arrayTable);

    if (sameField.length || crossField.length) {
      notification.error({
        message: "ไม่สามารถบันทึกได้ !",
        description: (
          <div>
            <div>เนื่องจากมีข้อมูลซ้ำกันกรุณาตรวจสอบข้อมูล !</div>

            {sameField.length > 0 && (
              <div style={{ marginTop: 8, color: "red" }}>
                ซ้ำกันในแถว:
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {[...new Set(sameField.map((d) => d.value))].map(
                    (value, index) => (
                      <li key={index}>{value}</li>
                    ),
                  )}
                </ul>
              </div>
            )}

            {crossField.length > 0 && (
              <div style={{ marginTop: 8, color: "orange" }}>
                ซ้ำข้ามคอลัมน์:
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {[...new Set(crossField.map((d) => d.value))].map(
                    (value, index) => (
                      <li key={index}>{value}</li>
                    ),
                  )}
                </ul>
              </div>
            )}
          </div>
        ),
        duration: 10,
      });

      setLoading(false);
      return;
    }

    const use = arrayTable.filter((r) => r.parcelNo && r.parcelNoResponse);
    console.log(use);

    putDataParcel(use);
  };

  const handleExportExcel = async () => {
    setLoading(true);

    console.log(selectedRows);

    let useData;
    if (selectedRows.length > 0) {
      useData = selectedRows;
    } else {
      useData = arrayTable;
    }

    try {
      await excelForPostOffice(useData, 1);
      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  // สร้าง validator function แยก
  const createParcelValidator = (fieldName) => {
    return async (_, value, index, arrayTable) => {
      if (!value) return Promise.resolve();

      const { sameField, crossField } = findParcelDuplicates(arrayTable);
      const currentRow = index + 1;

      const sameFieldIssue = sameField.find(
        (item) =>
          item.field === fieldName &&
          item.value === value &&
          item.rows.includes(currentRow),
      );

      const crossFieldIssue = crossField.find(
        (item) => item.value === value && item.rows.includes(currentRow),
      );

      // if (sameFieldIssue && crossFieldIssue) {
      //   return Promise.reject(
      //     new Error(`ซ้ำกับข้อมูลอื่นในแถว "EMS จดหมาย" และ "EMS ใบตอบกลับ"`)
      //   );
      // }

      if (sameFieldIssue) {
        const otherRows = sameFieldIssue.rows
          .filter((r) => r !== currentRow)
          .join(", ");
        const fieldLabel =
          fieldName === "parcelNo" ? "EMS จดหมาย" : "EMS ใบตอบกลับ";
        return Promise.reject(
          new Error(
            `ซ้ำกับข้อมูลอื่นในแถว "${fieldLabel}" (แถวที่: ${otherRows})`,
          ),
        );
      }

      if (crossFieldIssue) {
        const oppositeLabel =
          fieldName === "parcelNo" ? "EMS ใบตอบกลับ" : "EMS จดหมาย";
        return Promise.reject(
          new Error(`ซ้ำกับข้อมูลอื่นในแถว "${oppositeLabel}"`),
        );
      }

      return Promise.resolve();
    };
  };

  // ใช้งาน
  const renderParcelNo = (_, record, index) => (
    <Form.Item
      name={["rows", record.key, "parcelNo"]}
      style={{ margin: 0 }}
      rules={[
        { len: 13, message: "กรอกให้ครบ 13 หลัก" },
        {
          validator: (_, value) =>
            createParcelValidator("parcelNo")(_, value, index, arrayTable),
        },
      ]}
      getValueFromEvent={(e) => e.target.value}
    >
      <Input
        placeholder="กรอกเลข EMS จดหมาย"
        maxLength={13}
        minLength={13}
        ref={(el) => (mailRefs.current[index] = el)}
        onChange={(e) => {
          const v = e.target.value.trim();
          writeThrough(record.key, "parcelNo", v);
          if (v.length === 13) responseRefs.current[index]?.focus();
        }}
        onPressEnter={() => responseRefs.current[index]?.focus()}
      />
    </Form.Item>
  );

  const renderParcelNoResponse = (_, record, index) => (
    <Form.Item
      name={["rows", record.key, "parcelNoResponse"]}
      style={{ margin: 0 }}
      rules={[
        { len: 13, message: "กรอกให้ครบ 13 หลัก" },
        {
          validator: (_, value) =>
            createParcelValidator("parcelNoResponse")(
              _,
              value,
              index,
              arrayTable,
            ),
        },
      ]}
      getValueFromEvent={(e) => e.target.value}
    >
      <Input
        placeholder="กรอกเลข EMS ใบตอบกลับ"
        maxLength={13}
        minLength={13}
        ref={(el) => (responseRefs.current[index] = el)}
        onChange={(e) => {
          const v = e.target.value.trim();
          writeThrough(record.key, "parcelNoResponse", v);
          if (v.length === 13) mailRefs.current[index + 1]?.focus();
        }}
        onPressEnter={() => mailRefs.current[index + 1]?.focus()}
      />
    </Form.Item>
  );

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",

      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "contractNo",
      key: "contractNo",
      align: "center",

      render: (_, r) => r.contractNo || r.CONTNO || "-",
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "customerFullname",
      key: "customerFullname",
      align: "center",

      render: (_, r) => r.customerFullname || r.NAME || "-",
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",

      render: (_, r) =>
        r.customerTypeID === 0 ? "ผู้เช่าซื้อ" : `คนค้ำ ${r.customerTypeID}`,
    },
    {
      title: "ที่อยู่",
      align: "left",
      render: (_, r) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: 350,
          }}
        >
          {r.ADDR || "-"}
        </div>
      ),
    },

    {
      title: "ems จดหมาย",
      dataIndex: "parcelNo",
      key: "parcelNo",
      align: "center",
      width: 220,
      render: renderParcelNo,
    },
    {
      title: "ems ใบตอบกลับ",
      dataIndex: "parcelNoResponse",
      key: "parcelNoResponse",
      align: "center",
      width: 220,
      render: renderParcelNoResponse,
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const handleClear = () => {
    setOptionTime([]);
    setArrayTable([]);
    setOptionTimeSelect([]);
  };

  const btnSubmit = () => {
    form.submit(); // ส่งฟอร์มเมื่อกด "ยืนยัน"
  };

  const getListData = (value) => {
    return (
      calendarPoint?.filter((item) =>
        dayjs(item.docTime).isSame(value, "day"),
      ) || []
    );
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    return (
      <>
        {listData.length > 0 && (
          <div style={{ textAlign: "center", marginBottom: 4 }}>
            <Badge count={<InfoCircleOutlined style={{ color: "blue" }} />} />
          </div>
        )}
        {listData.map((item, index) => (
          <li key={index}>
            <Badge
              status="success"
              text={
                <div style={{ whiteSpace: "normal" }}>
                  <Link
                    onClick={() => {
                      // คลิกลิงก์ใน cell = เลือก "วัน"
                      setCalendarValue(dayjs(item.docTime));
                      setDatePicker(dayjs(item.docTime));
                      setBtnCheckCalendar(true);
                      queryData(true, item.docTime, true);
                    }}
                  >
                    ดูเพิ่มเติม
                  </Link>
                </div>
              }
            />
          </li>
        ))}
      </>
    );
  };

  const getMonthCount = (value) => {
    const targetMonth = value.month(); // 0-11
    const targetYear = value.year();

    const filtered = calendarPoint?.filter((item) => {
      const date = dayjs(item.docTime);
      return date.year() === targetYear && date.month() === targetMonth;
    });

    return filtered?.length || 0;
  };

  const monthCellRender = (value) => {
    const count = getMonthCount(value);

    return count > 0 ? (
      <div style={{ textAlign: "center", paddingTop: 8 }}>
        <Badge count={count} style={{ backgroundColor: "blue" }} />
      </div>
    ) : null;
  };

  const cellRender = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    if (info.type === "month") return monthCellRender(current);
    return info.originNode;
  };

  // --- เมื่อคลิกเลือกในปฏิทิน ---
  const handleSelect = (value /* dayjs */) => {
    console.log("handleSelect", value);

    if (calendarMode === "year") {
      // คลิก "เดือน" ขณะอยู่โหมดปี -> เปลี่ยนไปโหมดเดือนของเดือนนั้น (ไม่ query)
      setCalendarMode("month");
      setCalendarValue(value);
      return;
    }
    // setLoading(true);
    // โหมดเดือน: คลิก "วัน" -> อัปเดต/สั่งค้นหา
    setCalendarValue(value);
    setDatePicker(value);
    setBtnCheckCalendar(true);
    queryData(true, value, true);
  };

  // --- เมื่อเปลี่ยนแผง (สลับเดือน/ปี หรือเปลี่ยนเดือนจากหัวปฏิทิน) ---
  const handlePanelChange = (value, mode) => {
    console.log("handlePanelChange", value, mode);
    setCalendarValue(value);
    setCalendarMode(mode);
  };

  const CalendarList = () => (
    <div>
      <Calendar
        value={calendarValue}
        mode={calendarMode}
        onSelect={handleSelect}
        onPanelChange={handlePanelChange}
        cellRender={cellRender}
        headerRender={({ value, type, onChange, onTypeChange }) => {
          const cur = value.clone();
          const years = Array.from(
            { length: 11 },
            (_, i) => dayjs().year() - 5 + i,
          );
          const months = Array.from({ length: 12 }, (_, i) => ({
            value: i,
            label: dayjs().month(i).format("MMM"),
          }));
          return (
            <div
              style={{
                display: "flex",
                gap: 8,
                justifyContent: "flex-end",
                padding: 8,
              }}
            >
              <Select
                size="small"
                value={cur.year()}
                options={years.map((y) => ({ value: y, label: y }))}
                onChange={(y) => {
                  onChange(cur.year(y));
                  setBtnCheckCalendar(false);
                }}
              />
              <Select
                size="small"
                value={cur.month()}
                options={months}
                onChange={(m) => {
                  onChange(cur.month(m));
                  setBtnCheckCalendar(false);
                }}
                disabled={type === "year" ? true : false}
              />
              <Segmented
                size="small"
                value={type === "year" ? "Year" : "Month"}
                options={["Month", "Year"]}
                onChange={(v) => onTypeChange(v === "Year" ? "year" : "month")}
              />
            </div>
          );
        }}
      />
      <Row>
        <Col span={24} style={{ textAlign: "end" }}>
          <Button
            icon={<ArrowRightOutlined />}
            size="large"
            type="primary"
            danger
            ghost
            onClick={() => setBtnCheckCalendar(true)}
            disabled={loading}
          >
            ข้าม
          </Button>
        </Col>
      </Row>
    </div>
  );

  const TableData = () => {
    return (
      <div
        ref={scrollRef}
        style={{
          maxHeight: 800, // กำหนดความสูงให้เกิดสกอร์ล
          overflow: "auto",
          position: "relative", // ให้ float วางอิงกล่องนี้ได้
        }}
      >
        <Row>
          <Col span={"24"} style={{ textAlign: "center", marginBottom: 20 }}>
            <Button
              icon={<ArrowLeftOutlined />}
              size="large"
              type="primary"
              ghost
              onClick={() => {
                setBtnCheckCalendar(false);
                handleClear();
              }}
              disabled={loading}
            >
              ย้อนกลับ
            </Button>
            <Space
              size={16}
              direction="vertical"
              style={{ marginRight: 10, marginLeft: 10 }}
            >
              <ThaiDatePicker value={datePicker} onChange={setDatePicker} />
              {optionTime?.length !== 0 ? (
                <Select
                  placeholder="เลือกเวลา"
                  options={optionTime}
                  value={optionTimeSelect}
                  onChange={(val) => handleSelectTime(val)}
                  style={{ width: 180 }}
                  size="large"
                />
              ) : null}
            </Space>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="large"
              style={{
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                fontWeight: "bold",
                background: "linear-gradient(135deg, #667eea, blue)",
                border: "none",
                marginRight: "10px",
              }}
              onClick={queryData}
              disabled={loading}
            >
              ค้นหา
            </Button>
            <Button
              icon={<RestOutlined />}
              size="large"
              onClick={handleClear}
              type="default" // หรือ "dashed"
              danger
              style={{
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.06)",
                fontWeight: "bold",
              }}
              disabled={loading}
            >
              ล้างข้อมูล
            </Button>
          </Col>
        </Row>
        <Row gutter={[16, 16]} align="middle" wrap>
          <Col xs={24} md={12} style={{ textAlign: "start" }}>
            <Search
              enterButton="ค้นหา"
              placeholder="ค้นหาสัญญา"
              onChange={search}
              size="large" // small = 24px, middle = 32px, large = 40px
              style={{ width: "60%", maxWidth: 320, padding: 10 }} // พอดีสายตา, ไม่ยืดเกินไป
            />
          </Col>
          <Col xs={24} md={12} style={{ textAlign: "end" }}>
            <Space size={8} wrap>
              <Button
                type="primary"
                ghost
                icon={<SaveOutlined />}
                loading={loading}
                size="middle"
                style={{ borderRadius: 8, fontWeight: 600 }}
                onClick={() => btnSubmit()}
              >
                บันทึก
              </Button>

              <Button
                icon={<FileExcelOutlined />}
                size="middle"
                loading={loading}
                style={{
                  borderRadius: 8,
                  fontWeight: 600,
                  color: "#16a34a",
                  borderColor: "#16a34a",
                }}
                onClick={handleExportExcel}
              >
                ออก Excel
              </Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form
              form={form}
              onFinish={(values) => {
                const payload = arrayTable.map((r) => ({
                  ...r,
                  ...(values.rows?.[r.key] || {}),
                }));
                console.log("submit payload", payload);
                confirmInsert();
              }}
              onFinishFailed={(errorInfo) => {
                const fieldLabels = {
                  parcelNo: "ems จดหมาย",
                  parcelNoResponse: "ems ใบตอบกลับ",
                };

                // แปลง key → เลขแถว (index + 1)
                const keyToRowNo = (rowKey) => {
                  const i = arrayTable.findIndex(
                    (r) => String(r.key) === String(rowKey),
                  );
                  return i >= 0 ? i + 1 : rowKey;
                };
                notification.error({
                  message: "ไม่สามารถบันทึกได้ !",
                  description: (
                    <div>
                      <div
                        style={{
                          marginTop: 8,
                          color: "red",
                        }}
                      >
                        ข้อมูลไม่ครบในคอลัมน์และแถว
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                          {[
                            ...new Set(
                              errorInfo.errorFields.map((d) => {
                                const [, rowKey, field] = d.name || [];
                                const label = fieldLabels[field] || field;
                                return `คอลัมน์ ${label} ที่แถว ${keyToRowNo(
                                  rowKey,
                                )}`;
                              }),
                            ),
                          ].map((value, index) => (
                            <li key={index}>{value}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ),
                  duration: 6,
                });
                console.log("errorInfo", errorInfo);
              }}
            >
              <Table
                size="large"
                rowKey={(r) => r.key}
                columns={columns}
                dataSource={arrayTable}
                pagination={false}
                bordered
                style={{ marginTop: 16 }}
                footer={() => (
                  <div
                    style={{
                      textAlign: "right",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    จำนวนทั้งหมด {arrayTable.length}
                  </div>
                )}
                rowSelection={rowSelection}
              />
            </Form>
            <FloatButton.BackTop />
          </Col>
        </Row>
        <FloatButton.BackTop
          target={() => scrollRef.current} // ฟังสกอร์ลจากกล่องนี้
          visibilityHeight={80} // โผล่เมื่อเลื่อนเกิน 80px
          style={{ right: 16, bottom: 16 }}
        />
      </div>
    );
  };

  return (
    <Spin spinning={loading} size="large" tip=" Loading... ">
      <Modal
        title={
          <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
            รายการออกบอกเลิก
          </span>
        }
        open={open}
        onCancel={handleCancel}
        width={btnCheckCalendar ? "auto" : 850}
        footer={null}
        keyboard={true}
        maskClosable={false}
        centered
        styles={{
          body: { padding: "24px 32px" }, // ใช้แทน styles.body
        }}
      >
        {!btnCheckCalendar ? CalendarList() : TableData()}
      </Modal>
    </Spin>
  );
};
export default ExportCancel;
